export default "<!-- <button mat-reised-button (click)=\"navigateProductCreate()\">\n  Novo Produto\n</button> -->\n<eM-product-read></eM-product-read>\n";